const NUM_DIGITS_SEQ = 5;
const NUM_DIGITS_TS = 14;

let _oldTime = 0;
let _sequence = 0;

const timestamp = () => {
    const time = Date.now();

    if (time !== _oldTime) {
        _sequence = 0;
    }
    _oldTime = time;

    const result = `${time
        .toString()
        .padStart(NUM_DIGITS_TS, '0')}.${(_sequence++)
        .toString()
        .padStart(NUM_DIGITS_SEQ, '0')}`;

    return result;
};

export default timestamp;
